module.exports = __webpack_public_path__ + "media/packs/comprar-d3b12e51cd82fd5d34aea430c51af6c5.svg";